import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col" }
const _hoisted_2 = { class: "flex-grow flex relative z-10" }

import HeaderMain from "../Headers/HeaderMain.vue";
import FooterMain from "../Footers/FooterMain.vue";
import SidebarMain from "../Sidebars/SidebarMain.vue";
import AbortModal from "../Modal/AbortModal.vue";
import NotificationToast from "../Notifications/NotificationToast.vue";
import { onUnmounted, ref } from "vue";
import { useTasksStore } from "@/stores/v2";
import router from "@/router/v2";

// State

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutMain',
  setup(__props) {

const isSidebarActive = ref(false);
const abortModal = ref(false);
const sidebarRef = ref<Node | null>(null);
const tasksStore = useTasksStore();
// Methods
const sidebarToggler = () => {
  isSidebarActive.value = !isSidebarActive.value;
};

// Close the sidebar when clicking outside
const handleOutsideClick = (event: MouseEvent) => {
  if (
    isSidebarActive.value &&
    sidebarRef.value &&
    !sidebarRef.value.contains(event.target as Node)
  ) {
    isSidebarActive.value = false;
  }
};

const toggleAbortModal = () => {
  if (tasksStore.activeTask) {
    return (abortModal.value = !abortModal.value);
  }

  router.push("/select-site");
};

// Listen for clicks on the body element
document.body.addEventListener("click", handleOutsideClick, true);

// Cleanup the event listener when the component is unmounted
onUnmounted(() => {
  document.body.removeEventListener("click", handleOutsideClick);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderMain, {
      class: _normalizeClass([{ 'blur-sm': isSidebarActive.value }, "w-full transition-all duration-300 flex-shrink-0 relative z-10"]),
      sidebarToggler: sidebarToggler
    }, null, 8, ["class"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([{ 'blur-sm': isSidebarActive.value }, "container transition-all duration-300 mx-auto py-8 p-4 overflow-y-auto max-h-[calc(100vh-10rem)]"])
      }, [
        _renderSlot(_ctx.$slots, "mainArea")
      ], 2),
      _createVNode(AbortModal, {
        showModal: abortModal.value,
        toggleAbortModal: toggleAbortModal
      }, null, 8, ["showModal"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["fixed flex justify-end right-[-100%] z-20 top-0 h-screen w-screen overflow-x-hidden transition-all duration-300", { 'right-[0%]': isSidebarActive.value }])
    }, [
      _createElementVNode("div", {
        class: "h-full fixed",
        ref_key: "sidebarRef",
        ref: sidebarRef
      }, [
        _createVNode(SidebarMain, {
          class: _normalizeClass(["right-[-300px] shadow-md py-10 px-4 bg-primary w-[300px] h-full transition-all duration-500 ease-in-out", { 'right-0': isSidebarActive.value }]),
          showModal: abortModal.value,
          toggleAbortModal: toggleAbortModal
        }, null, 8, ["class", "showModal"])
      ], 512)
    ], 2),
    _createVNode(FooterMain, {
      class: _normalizeClass([{ 'blur-sm': isSidebarActive.value }, "w-full transition-all duration-300 flex-shrink-0 relative z-10"])
    }, null, 8, ["class"]),
    _createVNode(NotificationToast)
  ]))
}
}

})